(function() {
'use strict';

angular
    .module('dashboard')
    .controller('PayBalanceComplete', PayBalanceComplete);

function PayBalanceComplete(
    $scope,
    $routeParams,
    broker,
    dashboardBookingService,
    resourceService) {
    const cm = this;
    cm.bookingId = parseInt($routeParams.bookingId);
    cm.bookingActions = dashboardBookingService.getBookingActions();
    cm.getResourceValue = resource => resourceService.get(resource);

    broker.publish('paymentComplete');

    dashboardBookingService.getBookingDetail(cm.bookingId).then(function(data) {
        if (data) {
            const paymentData = _.last(data.Payments.filter(p => p.Status === 1));
            const dueDetail = data.BalanceDueInfo;
            cm.amountPaid = paymentData.Amount;
            cm.currencyCode = paymentData.ClientCurrencyCode;
            if (dueDetail) {
                cm.balanceDueAfterPayment = dueDetail.BalanceDueAmount - dueDetail.PendingElvPayments;
                cm.BalanceDueDate = dueDetail.DueDate;
            }
        }
    });

    //dashboardBookingService.getBookingInfo(cm.bookingId).then(function (booking) {
    //    cm.bk = booking;
    //});

    broker.publish('unblock');
    $scope.$emit('unblock');
}
})();
